import React, { useEffect, useState } from 'react';
import { PageHeaderLeftIcon } from '@shared/infrastructure/ui/components/header/pageHeader';
import { historyRepository } from '@shared/domain/router/router.repository';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { routeRepository } from '@shared/domain/router/route/route.repository';
import { ROUTES } from '@shared/infrastructure/router/paths';
import { useAppSelector } from '@shared/infrastructure/state/store';
import {
  countryCodeSelector,
  languageCodeSelector
} from '@shared/infrastructure/state/global.slice';
import { Content } from '@shared/domain/content/content.aggregate';
import { ContentEditLayout } from './contentEdit/contentEditLayout';
import { SubmitHandler, useForm } from 'react-hook-form';
import { Box, Button, IconButton } from '@mui/material';
import { contentRepository } from '@shared/domain/content/content.repository';
import { ContentInfo } from './contentEdit/contentInfo';
import { ContentSettings } from './contentEdit/contentSettings';

export const ContentEdit = () => {
  const countryCode = useAppSelector(countryCodeSelector);
  const languageCode = useAppSelector(languageCodeSelector);
  const { contentId } =
    routeRepository.getParams(
      ROUTES.CONTENTS_EDIT.path,
      window.location.pathname
    ) || {};

  const [content, setContent] = useState<Content>();
  useEffect(() => {
    contentRepository
      .getContents(countryCode, languageCode)
      .then((contents) => {
        const localContent = contents.find((t) => t.id === Number(contentId));
        setContent(localContent);
        reset(localContent);
      });
  }, [countryCode, languageCode, contentId]);

  const { control, handleSubmit, reset, watch } = useForm<Content>();
  const back = () =>
    historyRepository.push(
      routeRepository.buildRoute(ROUTES.CONTENTS.path, {})
    );
  const onSubmit: SubmitHandler<Content> = (data) => {
    contentRepository
      .updateContent(countryCode, languageCode, {
        ...content,
        ...data
      })
      .then(back, (error) => {
        throw error;
      });
  };

  if (!content) return null;

  const kind = watch('kind');

  return (
    <>
      <PageHeaderLeftIcon
        icon={
          <IconButton
            size='large'
            color='inherit'
            aria-label='back button'
            sx={{ mr: 2 }}
            onClick={back}
          >
            <ArrowBackIcon fontSize='large' />
          </IconButton>
        }
      >
        <Box sx={{ textAlign: 'center' }}>
          <p>Edit content</p>
          <p>
            <small>
              Country: {countryCode}, Language: {languageCode}
            </small>
          </p>
        </Box>
      </PageHeaderLeftIcon>
      <form onSubmit={handleSubmit(onSubmit)}>
        <ContentEditLayout
          left={<ContentInfo control={control} />}
          right={
            <ContentSettings control={control} disableKind={true} kind={kind} />
          }
          buttons={
            <Button
              sx={{
                marginTop: '1rem',
                padding: '1rem 1.5rem'
              }}
              type='submit'
              variant='contained'
              color='primary'
            >
              Save
            </Button>
          }
        ></ContentEditLayout>
      </form>
    </>
  );
};
